export const environment = {
    production: false,
    useMockServices: false,
    enableAuth: true,
    includeRND: true,
    showLogs: true,
    apiUrl: 'https://api-dev.paacapph.org',
    region: 'ap-southeast-1',
    bucketName: 'swiftrewards-paacap-dev-storage',
    cognitoUserPoolId: 'ap-southeast-1_YXAuh8v9t',
    cognitoAppClientId: '64qgp7ilj4u3572irm1bmqpekv',
    cognitoIdentityEndpoint: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_YXAuh8v9t',
    cognitoIdentityPoolId: 'ap-southeast-1:18bbc1b7-8e25-46f8-9f65-65626d287624',
    xAPIKey:'900cMfE8uc2FWZaWlh4n23gzfdbV8j6T9VR6XlSj'
};